import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  @Input() errorCode: number = 500;
  @Input() errorText: string = 'ERROR'; // требуется передавать ключ для языкового файла
  @Input() linkUrl:   string = '/';
  @Input() linkText:  string = 'BACK_TO_MAIN'; // требуется передавать ключ для языкового файла

  constructor() { }

  ngOnInit(): void {
  }
}
